import { ModelBase } from './ModelBase';
import { ContentAreaEnum } from './ContentAreaEnum';
//import { TopicFamilyModel } from './TopicFamilyModel';
import { ContentInfo } from './ContentInfo';
import { ContentEntryPublishRenderDescriptor } from './ContentEntryPublishRenderDescriptor'

export class TopicLeaf extends ModelBase {
    TopicInformation: ContentInfo = null;
    ThumbnailImageAssetId: string = '';
    Parent: TopicLeaf = null;
    Children: TopicLeaf[] = [];
    ContentArea: ContentAreaEnum = ContentAreaEnum.Courseware;
    contentEntries: ContentEntryPublishRenderDescriptor[] = [];
    ThumbnailFilename: string = null;

    public static topicLeaf2ContentInfo(theTopic: TopicLeaf)
    {
      var contentInfo: ContentInfo = {
        Alias: theTopic.TopicInformation.Alias,
        Title: theTopic.TopicInformation.Title,
        Description: theTopic.TopicInformation.Description
      }
      return contentInfo;
    }

}
